// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


input.error,
select.error,
textarea.error,
.system-combobox-input.error {
  border-color: #dc3545 !important;
  background-color: #fff8f8 !important;
}


.error-message:not(.range-error-message),
.required-error {
  display: none !important;
}


.error-message,
.range-error-message,
.required-error,
[class*="error-message"],
[class*="range-error"] {
  display: none !important;
}


.range-error-message {
  display: block !important;
  color: #dc3545;
  font-size: 12px;
  margin-top: 5px;
  font-weight: 500;
  animation: fadeIn 0.3s ease;
}


label:has(+ input.error),
label:has(+ select.error) {
  color: #dc3545;
}


.required-star {
  color: #dc3545;
  margin-left: 3px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.summary-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  color: #666;
}

.summary-row.discount {
  color: #0e0d0d;
  font-weight: 600;
}

.summary-row.total {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 2px solid #dee2e6;
  font-weight: 600;
  color: #333;
  font-size: 16px;
}


.summary-row:first-of-type {
  font-weight: 600;
}


.draft-items-list {
  margin-bottom: 20px;
  background-color: #fff8e7;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #000000;
}

.draft-items-list h3 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #000000;
}

.draft-items-container {
  max-height: 300px;
  overflow-y: auto;
}


.order-item-card.draft-item-card {
  background-color: #fff8e7;
  border: 1px solid #000000;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  transition: all 0.2s;
}

.order-item-card.draft-item-card:hover {
  border-color: #000000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}


.item-header.draft-item-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #000000;
}


.item-number.draft-number {
  background-color: transparent;
  color: #000000;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 10px;
  border: 1px solid #000000;
}


.item-system.draft-system {
  font-weight: 600;
  color: #000000;
  flex: 1 1;
}


.item-actions.draft-actions {
  display: flex;
  gap: 5px;
}

.item-edit-btn.draft-edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 2px 5px;
  border-radius: 4px;
  transition: all 0.2s;
  color: #000000;
}

.item-edit-btn.draft-edit-btn:hover {
  background-color: #e9ecef;
}

.item-remove-btn.draft-remove-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 2px 5px;
  border-radius: 4px;
  transition: all 0.2s;
  color: #dc3545;
}

.item-remove-btn.draft-remove-btn:hover {
  background-color: #f8d7da;
}


.draft-details {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
}

.draft-details .item-details-left {
  flex: 1 1;
  min-width: 200px;
}


.draft-detail {
  display: flex;
  align-items: center;
  padding: 4px 0;
  border-bottom: none !important;
}

.draft-details .item-details-left .draft-detail {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.draft-details .item-details-left .detail-label {
  width: 75px;
  flex-shrink: 0;
  color: #000000;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
}

.draft-details .item-details-left .detail-value {
  flex: 0 1 auto;
  color: #000000;
  font-size: 11px;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
}


.item-notes.draft-notes {
  flex: 0 0 100%;
  margin-top: 8px;
  padding: 6px;
  background-color: #fff8e7;
  border-radius: 4px;
  color: #000000;
  font-size: 11px;
  font-style: italic;
  border: 1px dashed #000000;
}


.loading-drafts {
  text-align: center;
  padding: 20px;
  color: #000000;
  font-style: italic;
}



.order-items-list {
  margin-bottom: 25px;
}

.order-items-list h3 {
  margin: 0 0 15px 0;
  color: #080808;
  font-size: 16px;
}

.no-items {
  text-align: center;
  padding: 30px;
  color: #0c0c0c;
  font-style: italic;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.items-container {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 5px;
}

.items-container::-webkit-scrollbar {
  width: 6px;
}

.items-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.items-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.items-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}


.order-item-card {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  transition: all 0.2s;
}

.order-item-card:hover {
  border-color: #edec5b;
  box-shadow: 0 2px 4px rgba(108, 92, 231, 0.1);
}

.order-item-card.editing {
  border: 2px solid #edec5b;
  background-color: #f0ebff;
}


.item-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #dee2e6;
}

.item-number {
  background-color: #edec5b;
  color: rgb(7, 7, 7);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 10px;
}

.item-system {
  font-weight: 600;
  color: #333;
  flex: 1 1;
  font-size: 13px;
}

.item-actions {
  display: flex;
  gap: 5px;
}

.item-edit-btn, .item-remove-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 2px 5px;
  border-radius: 4px;
  transition: all 0.2s;
}

.item-edit-btn {
  color: #edec5b;
}

.item-edit-btn:hover {
  background-color: #e9ecef;
}

.item-remove-btn {
  color: #dc3545;
}

.item-remove-btn:hover {
  background-color: #f8d7da;
}


.item-details {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
}


.item-details-left {
  flex: 1 1;
  min-width: 180px;
}


.item-details-right {
  flex-shrink: 0;
  text-align: right;
}


.item-detail {
  display: flex;
  align-items: center;
  padding: 3px 0;
  border-bottom: none !important;
}


.item-details-left .item-detail {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.item-details-left .detail-label {
  width: 85px;
  flex-shrink: 0;
  color: #080808;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
}

.item-details-left .detail-value {
  flex: 1 1;
  color: #050505;
  font-size: 11px;
  font-weight: 600;
  text-align: left;
  word-break: break-word;
}


.item-details-right .item-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 3px 0;
  border-bottom: none !important;
}

.item-details-right .detail-label {
  color: #666;
  font-size: 11px;
  font-weight: 500;
  text-align: right;
}

.item-details-right .detail-value {
  color: #080808;
  font-size: 12px;
  font-weight: 700;
  text-align: right;
  min-width: 65px;
}


.item-detail.price .detail-value,
.item-detail.sum .detail-value {
  color: #080808;
  font-weight: 700;
  font-size: 12px;
}

.item-detail.price .detail-label,
.item-detail.sum .detail-label {
  font-weight: 600;
  font-size: 11px;
}


.item-detail,
.item-detail:last-child,
.item-details-left .item-detail,
.item-details-right .item-detail {
  border-bottom: none !important;
}


.item-notes {
  flex: 0 0 100%;
  margin-top: 8px;
  padding: 6px;
  background-color: #fff3cd;
  border-radius: 4px;
  color: #856404;
  font-size: 11px;
  font-style: italic;
}


@media (max-width: 768px) {
  .item-details {
    flex-direction: column;
    gap: 10px;
  }
  
  .item-details-left {
    width: 100%;
  }
  
  .item-details-right {
    width: 100%;
  }
  
  .item-details-right .item-detail {
    justify-content: space-between;
  }
  
  .item-details-right .detail-label {
    text-align: left;
  }
  
  .item-details-right .detail-value {
    text-align: right;
  }
}


.item-details {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.item-details-left {
  flex: 2 1;
  min-width: 200px;
}

.item-details-right {
  flex: 1 1;
  min-width: 180px;
}


.item-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px dashed #f0f0f0;
  gap: 10px;
}

.item-detail:last-child {
  border-bottom: none;
}

.detail-label {
  color: #666;
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
  text-align: left;
}

.detail-value {
  color: #333;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  flex-shrink: 0;
}


.item-details-right .item-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.item-details-right .detail-label {
  text-align: left;
  flex: 1 1;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.4;
}

.item-details-right .detail-value {
  text-align: right;
  flex-shrink: 0;
  white-space: nowrap;
}


.item-detail.price .detail-value,
.item-detail.sum .detail-value {
  color: #080808;
  font-weight: 700;
  font-size: 13px;
}

.item-detail.price .detail-label,
.item-detail.sum .detail-label {
  font-weight: 600;
}


@media (max-width: 768px) {
  .item-details {
    flex-direction: column;
    gap: 10px;
  }
  
  .item-details-left,
  .item-details-right {
    min-width: 100%;
  }
  
  .item-details-right .item-detail {
    justify-content: space-between;
    align-items: center;
  }
  
  .item-details-right .detail-label {
    flex: 1 1;
  }
}
.order-page {
    padding: 20px;
    max-width: 1600px;
    margin: 0 auto;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
    background-color: #f5f5f5;
    min-height: 100vh;
  }
  
  
  .order-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding: 15px 20px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  .header-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  
  .my-orders-btn {
    padding: 10px 20px;
    background-color: #edec5b;
    color: rgb(0, 0, 0);
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
  }
  
  .my-orders-btn:hover {
    background-color: #f8f894;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(108, 92, 231, 0.3);
  }
  
  .dealer-info {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .dealer-label {
    color: #666;
    font-size: 14px;
  }
  
  .dealer-name {
    font-weight: 600;
    color: #333;
    font-size: 16px;
  }
  
  .save-draft-btn {
    padding: 10px 25px;
    background-color: #edec5b;
    color: #333;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
  }
  
  .save-draft-btn:hover:not(:disabled) {
    background-color: #ffb300;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 193, 7, 0.3);
  }
  
  .save-draft-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  
  .order-content {
    display: flex;
    gap: 30px;
  }
  
  .left-column {
    flex: 2 1;
  }
  
  .right-column {
    flex: 1.2 1;
  }
  
  
  .order-info-card {
    background-color: white;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    position: sticky;
    top: 20px;
  }
  
  .order-number-header {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid #f0f0f0;
  }
  
  .order-number-header h2 {
    margin: 0;
    color: #333;
    font-size: 20px;
  }
  
  
  .order-items-list {
    margin-bottom: 25px;
  }
  
  .order-items-list h3 {
    margin: 0 0 15px 0;
    color: #080808;
    font-size: 16px;
  }
  
  .no-items {
    text-align: center;
    padding: 30px;
    color: #0c0c0c;
    font-style: italic;
    background-color: #f9f9f9;
    border-radius: 8px;
  }
  
  .items-container {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 5px;
  }
  
  .items-container::-webkit-scrollbar {
    width: 6px;
  }
  
  .items-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  
  .items-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }
  
  .items-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  
  .order-item-card {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 10px;
    transition: all 0.2s;
  }
  
  .order-item-card:hover {
    border-color: #edec5b;
    box-shadow: 0 2px 4px rgba(108, 92, 231, 0.1);
  }
  
  .order-item-card.editing {
    border: 2px solid #edec5b;
    background-color: #f0ebff;
  }
  
  .item-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px dashed #dee2e6;
  }
  
  .item-number {
    background-color: #edec5b;
    color: rgb(7, 7, 7);
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    margin-right: 10px;
  }
  
  .item-system {
    font-weight: 600;
    color: #333;
    flex: 1 1;
  }
  
  .item-actions {
    display: flex;
    gap: 5px;
  }
  
  .item-edit-btn, .item-remove-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
    padding: 2px 5px;
    border-radius: 4px;
    transition: all 0.2s;
  }
  
  .item-edit-btn {
    color: #edec5b;
  }
  
  .item-edit-btn:hover {
    background-color: #e9ecef;
  }
  
  .item-remove-btn {
    color: #dc3545;
  }
  
  .item-remove-btn:hover {
    background-color: #f8d7da;
  }
  
  .item-details {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    font-size: 13px;
  }
  
  .item-detail {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 5px);
    display: flex;
    justify-content: space-between;
    color: #666;
  }
  
  .item-detail .detail-label {
    color: #0c0c0c;
  }
  
  .item-detail .detail-value {
    font-weight: 500;
    color: #333;
  }
  
  .item-detail.price .detail-value,
  .item-detail.sum .detail-value {
    font-weight: 600;
    color: #030303;
  }
  
  .item-notes {
    flex: 0 0 100%;
    margin-top: 8px;
    padding: 6px;
    background-color: #fff3cd;
    border-radius: 4px;
    color: #856404;
    font-size: 12px;
    font-style: italic;
  }
  
  
  .order-summary {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
  }
  
  .order-summary h3 {
    margin: 0 0 15px 0;
    color: #333;
    font-size: 16px;
  }
  
  .summary-row {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    color: #666;
  }
  
  .summary-row.discount {
    color: #0e0d0d;
  }
  
  .summary-row.total {
    margin-top: 8px;
    padding-top: 12px;
    border-top: 2px solid #dee2e6;
    font-weight: 600;
    color: #333;
    font-size: 16px;
  }
  
  
  .order-disclaimer {
    background-color: #fff3cd;
    border-left: 4px solid #ffc107;
    padding: 12px 15px;
    margin-bottom: 20px;
    border-radius: 4px;
  }
  
  .order-disclaimer p {
    margin: 5px 0;
    color: #856404;
    font-size: 13px;
  }
  
  
  .order-notes {
    margin-bottom: 20px;
  }
  
  .order-notes h3 {
    margin: 0 0 10px 0;
    color: #080808;
    font-size: 16px;
  }
  
  .order-notes textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #b5babd;
    color: #000000;
    border-radius: 8px;
    font-size: 14px;
    resize: vertical;
    transition: all 0.2s;
  }
  
  .order-notes textarea:focus {
    outline: none;
    border-color: #edec5b;
    box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);
  }
  
  
  .confirm-order-btn {
    width: 100%;
    padding: 15px;
    background-color: #4a4542;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    transition: all 0.2s;
  }
  
  .confirm-order-btn:hover:not(:disabled) {
    background-color: #5f5d5c;
    transform: translateY(-2px);
    box-shadow: #5f5d5c;
  }
  
  .confirm-order-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  
  .form-section {
    background-color: white;
    border-radius: 10px;
    padding: 25px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    margin-bottom: 0;
  }
  
  .form-section h3 {
    margin-top: 0;
    margin-bottom: 20px;
    color: #333;
    font-size: 18px;
  }
  
  .form-row {
    display: flex;
    gap: 15px;
    margin-bottom: 15px;
    flex-wrap: wrap;
  }
  
  .form-group {
    flex: 1 1;
    min-width: 200px;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 5px;
    color: #080808;
    font-size: 13px;
    font-weight: 500;
  }
  
  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    font-size: 14px;
    transition: all 0.2s;
  }
  
  .form-group input:focus,
  .form-group select:focus,
  .form-group textarea:focus {
    outline: none;
    border-color: #edec5b;
    box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);
  }
  
  .form-group input.error,
  .form-group select.error {
    border-color: #dc3545;
  }
  
  .error-message {
    color: #dc3545;
    font-size: 12px;
    margin-top: 4px;
  }
  
  .help-text {
    color: #6c757d;
    font-size: 12px;
    margin-top: 4px;
    font-style: italic;
  }
  
  
  .required-star {
    color: #dc3545;
    margin-left: 2px;
    font-size: 14px;
  }
  
  .optional-star {
    color: #6c757d;
    margin-left: 4px;
    font-size: 11px;
    font-style: italic;
    font-weight: normal;
  }
  
  
  .user-discount-info {
    background-color: #e7f5ff;
    border-left: 4px solid #edec5b;
    padding: 12px 15px;
    margin-bottom: 20px;
    border-radius: 4px;
    color: #070707;
    font-size: 14px;
  }
  
  .user-discount-info strong {
    color: #edec5b;
    font-size: 16px;
  }
  
  
  .system-type-info {
    background-color: #f8f9fa;
    padding: 10px 15px;
    margin-bottom: 20px;
    border-radius: 6px;
    color: #080808;
    font-size: 14px;
  }
  
  .system-type-info strong {
    color: #edec5b;
  }
  
  
  .price-type-info {
    background-color: #fff3cd;
    border-left: 4px solid #ffc107;
    padding: 10px 15px;
    margin-bottom: 20px;
    border-radius: 4px;
    color: #856404;
    font-size: 14px;
  }
  
  
  .price-loading {
    background-color: #e7f5ff;
    padding: 15px;
    border-radius: 6px;
    margin: 15px 0;
    text-align: center;
    color: #edec5b;
    font-style: italic;
  }
  
  .price-result {
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 6px;
    padding: 15px;
    margin: 15px 0;
  }
  
  .price-result p {
    margin: 8px 0;
    color: #155724;
  }
  
  .price-result .discount {
    background-color: #fff3cd;
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-block;
    color: #856404;
    font-size: 13px;
  }
  
  .price-result .final-price {
    font-weight: bold;
    font-size: 16px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #c3e6cb;
  }
  
  .price-result .final-price strong {
    color: #030303;
    font-size: 18px;
  }
  
  .price-error {
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    border-radius: 6px;
    padding: 15px;
    margin: 15px 0;
    color: #721c24;
  }
  
  
  .form-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
  }
  
  .add-item-btn {
    flex: 2 1;
    padding: 12px;
    background-color: #edec5b;
    color: rgb(0, 0, 0);
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
    transition: all 0.2s;
  }
  
  .add-item-btn:hover:not(:disabled) {
    background-color: #f8f894;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(201, 231, 92, 0.3);
  }
  
  .add-item-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .cancel-edit-btn {
    flex: 1 1;
    padding: 12px;
    background-color: #6c757d;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;
  }
  
  .cancel-edit-btn:hover {
    background-color: #5a6268;
  }
  
  
  .orders-list-modal {
    background-color: white;
    border-radius: 10px;
    padding: 25px;
    margin-bottom: 30px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
  
  .orders-list-modal h2 {
    margin-top: 0;
    margin-bottom: 20px;
    color: #333;
    font-size: 20px;
  }
  
  .orders-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
  }
  
  .order-card {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.2s;
  }
  
  .order-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  
  .order-card.draft {
    border-left: 4px solid #ffc107;
  }
  
  .order-card.confirmed {
    border-left: 4px solid #080808;
  }
  
  .order-card.archived {
    border-left: 4px solid #6c757d;
    opacity: 0.8;
  }
  
  .order-card-header {
    background-color: #f8f9fa;
    padding: 12px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e9ecef;
  }
  
  .order-number {
    font-weight: 600;
    color: #333;
  }
  
  .order-status {
    font-size: 12px;
    padding: 3px 8px;
    border-radius: 12px;
    font-weight: 500;
  }
  
  .order-status.draft {
    background-color: #fff3cd;
    color: #856404;
  }
  
  .order-status.confirmed {
    background-color: #d4edda;
    color: #155724;
  }
  
  .order-status.archived {
    background-color: #e2e3e5;
    color: #383d41;
  }
  
  .order-card-body {
    padding: 15px;
    background-color: #dcdcda;
  }
  
  .order-card-body div {
    margin-bottom: 6px;
    color: #080808;
    font-size: 14px;
  }
  
  .order-card-actions {
    padding: 12px 15px;
    display: flex;
    gap: 8px;
    border-top: 1px solid #e9ecef;
    background-color: #dcdcda;
  }
  
  .order-card-actions button {
    flex: 1 1;
    padding: 6px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s;
  }
  
  .order-card-actions button:first-child {
    background-color: #edec5b;
    color: rgb(0, 0, 0);
  }
  
  .order-card-actions button:nth-child(2) {
    background-color: #070707;
    color: white;
  }
  
  .order-card-actions button:last-child {
    background-color: #ffc107;
    color: #333;
  }
  
  .order-card-actions button:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .no-orders {
    text-align: center;
    padding: 40px;
    color: #6c757d;
    font-style: italic;
  }
  
  
  .confirm-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1100;
  }
  
  .confirm-dialog {
    background-color: white;
    padding: 25px;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    max-width: 400px;
    width: 90%;
  }
  
  .confirm-dialog p {
    margin: 0 0 20px 0;
    font-size: 16px;
    color: #333;
  }
  
  .confirm-dialog-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  
  .confirm-dialog-buttons button {
    padding: 8px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
  }
  
  .confirm-btn {
    background-color: #dc3545;
    color: white;
  }
  
  .confirm-btn:hover {
    background-color: #c82333;
  }
  
  .cancel-btn {
    background-color: #6c757d;
    color: white;
  }
  
  .cancel-btn:hover {
    background-color: #5a6268;
  }
  
  
  .dark-theme .order-page {
    background-color: #ffffff;
  }
  
  .dark-theme .order-header,
  .dark-theme .form-section,
  .dark-theme .order-info-card,
  .dark-theme .orders-list-modal {
    background-color: #dcdcda;
    border-color: #404040;
  }
  
  .dark-theme .dealer-label {
    color: #000000;
  }
  
  .dark-theme .dealer-name {
    color: #000000;
  }
  
  .dark-theme .order-number-header h2 {
    color: #000000;
  }
  
  .dark-theme .order-item-card {
    background-color: #b5babd;
    border-color: #404040;
  }
  
  .dark-theme .item-system {
    color: #000000;
  }
  
  .dark-theme .item-detail {
    color: #000000;
  }
  
  .dark-theme .item-detail .detail-value {
    color: #000000;
  }
  
  .dark-theme .order-summary {
    background-color: #b5babd;
  }
  
  .dark-theme .form-group label {
    color: #000000;
  }
  
  .dark-theme .form-group input,
  .dark-theme .form-group select,
  .dark-theme .form-group textarea {
    background-color: #b5babd;
    border-color: #080808;
    color: #030303;
  }
  
  .dark-theme .form-group input:focus,
  .dark-theme .form-group select:focus,
  .dark-theme .form-group textarea:focus {
    border-color: #edec5b;
  }
  
  
  @media (max-width: 1200px) {
    .order-content {
      flex-direction: column;
    }
    
    .right-column {
      flex: 1 1;
    }
    
    .order-info-card {
      position: static;
    }
  }
  
  @media (max-width: 768px) {
    .order-header {
      flex-direction: column;
      gap: 15px;
      align-items: stretch;
    }
    
    .header-left {
      flex-direction: column;
      gap: 10px;
    }
    
    .form-row {
      flex-direction: column;
      gap: 10px;
    }
    
    .form-group {
      min-width: 100%;
    }
    
    .form-actions {
      flex-direction: column;
    }
    
    .orders-grid {
      grid-template-columns: 1fr;
    }
  }
  .current-price-result {
    background-color: #e8f4fd;
    border: 1px solid #b8e0ff;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
  }
  
  .current-price-result h3 {
    margin: 0 0 10px 0;
    font-size: 16px;
    color: #0066cc;
  }
  
  .price-result-compact p {
    margin: 5px 0;
    font-size: 14px;
  }
  
  .price-result-compact .final-price {
    font-weight: bold;
    color: #070707;
    font-size: 16px;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px dashed #b8e0ff;
  }
  .range-error-message {
    color: #dc3545;
    font-size: 12px;
    margin-top: 4px;
    font-weight: 500;
    background-color: #f8d7da;
    padding: 4px 8px;
    border-radius: 4px;
    border-left: 3px solid #dc3545;
  }
  
  .form-group input.error,
  .form-group select.error {
    border-color: #dc3545;
    background-color: #fff8f8;
  }
  
  .form-group input.error:focus,
  .form-group select.error:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
  }
  
  .current-price-result {
    background-color: #e8f4fd;
    border: 1px solid #b8e0ff;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
  }
  
  .current-price-result h3 {
    margin: 0 0 10px 0;
    font-size: 16px;
    color: #0066cc;
  }
  
  .price-result-compact p {
    margin: 5px 0;
    font-size: 14px;
  }
  
  .price-result-compact .final-price {
    font-weight: bold;
    color: #030303;
    font-size: 16px;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px dashed #b8e0ff;
  }
  
  .add-item-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #585756;
  }

  .current-price-result {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
  }
  
  .current-price-result h3 {
    margin: 0 0 15px 0;
    font-size: 16px;
    color: #050505;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 10px;
  }
  
  .current-item-info {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px dashed #dee2e6;
  }
  
  .info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 14px;
  }
  
  .info-label {
    color: #050505;
    font-weight: 500;
  }
  
  .info-value {
    color: #212529;
    font-weight: 600;
  }
  
  .price-calculation {
    background-color: white;
    border-radius: 6px;
    padding: 10px;
  }
  
  .summary-row {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    color: #050505;
    font-size: 14px;
  }
  
  .summary-row.discount {
    color: #070707;
  }
  
  .summary-row.total {
    margin-top: 8px;
    padding-top: 12px;
    border-top: 2px solid #dee2e6;
    font-weight: 600;
    color: #030303;
    font-size: 16px;
  }
  
  .summary-row.price-per-unit {
    margin-top: 5px;
    padding-top: 5px;
    border-top: 1px dashed #dee2e6;
    font-style: italic;
    color: #050505;
  }

  
.fabric-code-group {
  position: relative;
}

.fabric-code-input {
  display: flex;
  gap: 5px;
}

.fabric-code-input input {
  flex: 1 1;
}

.fabric-select-btn {
  width: 40px;
  background-color: #edec5b;
  color: rgb(0, 0, 0);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  transition: all 0.2s;
}

.fabric-select-btn:hover {
  background-color: #f8f894;
}

.selected-fabric-info {
  margin-top: 5px;
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
}


.fabric-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.2s ease;
}

.fabric-modal {
  background-color: white;
  border-radius: 12px;
  width: 90%;
  max-width: 1000px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

.fabric-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #dee2e6;
}

.fabric-modal-header h2 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #0c0c0c;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #dc3545;
}

.fabric-search {
  padding: 12px 20px;
  border-bottom: 1px solid #dee2e6;
}

.fabric-search input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.fabric-search input:focus {
  outline: none;
  border-color: #edec5b;
}

.fabric-grid-container {
  flex: 1 1;
  overflow-y: auto;
  padding: 15px;
  max-height: 60vh;
}

.fabric-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
}

.fabric-item {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s;
  background-color: white;
}

.fabric-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-color: #edec5b;
}

.fabric-item.selected {
  border-color: #edec5b;
  background-color: #f0ebff;
  box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2);
}

.fabric-image {
  height: 100px;
  overflow: hidden;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fabric-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fabric-info {
  padding: 8px;
  text-align: center;
}

.fabric-code {
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
  font-size: 12px;
}

.fabric-price-group {
  color: #070707;
  font-size: 10px;
  font-weight: 500;
}

.no-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-size: 11px;
  background-color: #f8f9fa;
}

.loading-fabrics {
  text-align: center;
  padding: 30px;
  color: #6c757d;
  font-size: 14px;
  font-style: italic;
}

.fabric-modal-footer {
  padding: 12px 20px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.fabric-modal-footer .cancel-btn {
  padding: 8px 16px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s;
}

.fabric-modal-footer .cancel-btn:hover {
  background-color: #5a6268;
}

.fabric-modal-footer .confirm-btn {
  padding: 8px 24px;
  background-color: #edec5b;
  color: rgb(0, 0, 0);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.fabric-modal-footer .confirm-btn:hover:not(:disabled) {
  background-color: #f8f894;
}

.fabric-modal-footer .confirm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}


@media (max-width: 768px) {
  .fabric-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 10px;
  }
  
  .fabric-image {
    height: 80px;
  }
  
  .fabric-code {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .fabric-grid {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 8px;
  }
  
  .fabric-image {
    height: 70px;
  }
  
  .fabric-code {
    font-size: 10px;
  }
}

.fabric-type {
  color: #6c757d;
  font-size: 12px;
  margin-bottom: 4px;
}

.fabric-price-group {
  color: #0a0a0a;
  font-size: 12px;
  font-weight: 500;
}

.loading-fabrics {
  text-align: center;
  padding: 40px;
  color: #6c757d;
  font-size: 16px;
  font-style: italic;
}

.fabric-modal-footer {
  padding: 20px 25px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.fabric-modal-footer .cancel-btn {
  padding: 10px 20px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.fabric-modal-footer .cancel-btn:hover {
  background-color: #5a6268;
}

.fabric-modal-footer .confirm-btn {
  padding: 10px 30px;
  background-color: #edec5b;
  color: rgb(0, 0, 0);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.fabric-modal-footer .confirm-btn:hover:not(:disabled) {
  background-color: #f8f894;
}

.fabric-modal-footer .confirm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}


.dark-theme .fabric-modal {
  background-color: #dcdcda;
}

.dark-theme .fabric-modal-header {
  border-bottom-color: #404040;
}

.dark-theme .fabric-modal-header h2 {
  color: #020202;
}

.dark-theme .fabric-search {
  border-bottom-color: #404040;
}

.dark-theme .fabric-search input {
  background-color: #b5babd;
  border-color: #080808;
  color: #020202;
}

.dark-theme .fabric-item {
  background-color: #b5babd;
  border-color: #404040;
}

.dark-theme .fabric-item.selected {
  background-color: #edec5b;
  border-color: #edec5b;
}

.dark-theme .fabric-code {
  color: #020202;
}

.dark-theme .fabric-type {
  color: #b0b0b0;
}

.dark-theme .fabric-modal-footer {
  border-top-color: #404040;
}


.system-combobox {
  position: relative;
  width: 100%;
}

.system-combobox-input {
  width: 100%;
  padding: 10px 35px 10px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
  background-color: #fff;
  cursor: pointer;
}

.system-combobox-input:focus {
  outline: none;
  border-color: #edec5b;
  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);
}

.system-combobox-input.error {
  border-color: #dc3545;
}

.system-combobox-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 12px;
  color: #6c757d;
  cursor: pointer;
  padding: 0 4px;
  transition: color 0.2s;
}

.system-combobox-btn:hover {
  color: #edec5b;
}

.system-combobox-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  margin-top: 4px;
}

.system-combobox-item {
  padding: 10px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.system-combobox-item:last-child {
  border-bottom: none;
}

.system-combobox-item:hover {
  background-color: #f8f9fa;
  color: #edec5b;
}

.system-combobox-item.selected {
  background-color: #edec5b20;
  color: #edec5b;
  font-weight: 500;
}


.dark-theme .system-combobox-input {
  background-color: #b5babd;
  border-color: #404040;
  color: #030303;
}

.dark-theme .system-combobox-input:focus {
  border-color: #edec5b;
}

.dark-theme .system-combobox-btn {
  color: #a0a0a0;
}

.dark-theme .system-combobox-btn:hover {
  color: #edec5b;
}

.dark-theme .system-combobox-dropdown {
  background-color: #2d2d2d;
  border-color: #404040;
}

.dark-theme .system-combobox-item {
  color: #e0e0e0;
  border-bottom-color: #404040;
}

.dark-theme .system-combobox-item:hover {
  background-color: #3d3d3d;
  color: #edec5b;
}

.system-combobox {
  position: relative;
  width: 100%;
}

.system-combobox-input {
  width: 100%;
  padding: 10px 35px 10px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
  background-color: #fff;
}

.system-combobox-input:focus {
  outline: none;
  border-color: #edec5b;
  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);
}

.system-combobox-input.error {
  border-color: #dc3545;
}

.system-combobox-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 12px;
  color: #6c757d;
  cursor: pointer;
  padding: 0 4px;
  transition: color 0.2s;
}

.system-combobox-btn:hover {
  color: #edec5b;
}

.system-combobox-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  margin-top: 4px;
}

.system-combobox-item {
  padding: 10px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.system-combobox-item:last-child {
  border-bottom: none;
}

.system-combobox-item:hover {
  background-color: #f8f9fa;
  color: #edec5b;
}

.system-combobox-item.selected {
  background-color: #edec5b20;
  color: #edec5b;
  font-weight: 500;
}


.form-row.full-width {
  width: 100%;
}

.form-group.full-width {
  width: 100%;
}


.dark-theme .system-combobox-input {
  background-color: #b5babd;
  border-color: #404040;
  color: #030303;
}

.dark-theme .system-combobox-input:focus {
  border-color: #edec5b;
}

.dark-theme .system-combobox-btn {
  color: #a0a0a0;
}

.dark-theme .system-combobox-btn:hover {
  color: #edec5b;
}

.dark-theme .system-combobox-dropdown {
  background-color: #2d2d2d;
  border-color: #404040;
}

.dark-theme .system-combobox-item {
  color: #e0e0e0;
  border-bottom-color: #404040;
}

.dark-theme .system-combobox-item:hover {
  background-color: #3d3d3d;
  color: #edec5b;
}

.text-left {
  text-align: left !important;
}

.form-group label {
  text-align: left;
  display: block;
}

.save-draft-item-btn {
  flex: 1 1;
  padding: 12px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.save-draft-item-btn:hover:not(:disabled) {
  background-color: #5a6268;
}

.save-draft-item-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}



.draft-items-list {
  margin-bottom: 20px;
  background-color: #fff8e7;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #000000;
}

.draft-items-list h3 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #000000;
}

.draft-items-container {
  max-height: 300px;
  overflow-y: auto;
}


.order-item-card.draft-item-card {
  background-color: #fff8e7;
  border: 1px solid #000000;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  transition: all 0.2s;
}

.order-item-card.draft-item-card:hover {
  border-color: #000000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}


.item-header.draft-item-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #000000;
}


.item-number.draft-number {
  background-color: #edec5b;
  color: #000000;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 10px;
  border: 1px solid #000000;
}


.item-system.draft-system {
  font-weight: 600;
  color: #000000;
  flex: 1 1;
}


.item-actions.draft-actions {
  display: flex;
  gap: 5px;
}

.item-edit-btn.draft-edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 2px 5px;
  border-radius: 4px;
  transition: all 0.2s;
  color: #000000;
}

.item-edit-btn.draft-edit-btn:hover {
  background-color: #e9ecef;
}

.item-remove-btn.draft-remove-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 2px 5px;
  border-radius: 4px;
  transition: all 0.2s;
  color: #dc3545;
}

.item-remove-btn.draft-remove-btn:hover {
  background-color: #f8d7da;
}


.item-details.draft-details {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 13px;
}

.item-detail.draft-detail {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 5px);
  display: flex;
  justify-content: space-between;
  color: #000000;
}

.item-detail.draft-detail .detail-label {
  color: #000000;
}

.item-detail.draft-detail .detail-value {
  font-weight: 500;
  color: #000000;
}


.item-notes.draft-notes {
  flex: 0 0 100%;
  margin-top: 8px;
  padding: 6px;
  background-color: #fff8e7;
  border-radius: 4px;
  color: #000000;
  font-size: 12px;
  font-style: italic;
  border: 1px dashed #000000;
}


.loading-drafts {
  text-align: center;
  padding: 20px;
  color: #000000;
  font-style: italic;
}


.draft-items-list {
  margin-bottom: 20px;
  background-color: #fff8e7;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #ffc107;
}

.draft-items-list h3 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #856404;
}

.draft-items-container {
  max-height: 300px;
  overflow-y: auto;
}

.draft-item-card {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 8px;
}

.draft-item-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 5px;
  border-bottom: 1px dashed #ffeeba;
}

.draft-number {
  background-color: #ffc107;
  color: #333;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  margin-right: 8px;
}

.draft-system {
  font-weight: 500;
  color: #856404;
  flex: 1 1;
  font-size: 12px;
}

.draft-actions {
  display: flex;
  gap: 5px;
}

.draft-edit-btn, .draft-remove-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 4px;
}

.draft-edit-btn {
  color: #edec5b;
}

.draft-edit-btn:hover {
  background-color: #e9ecef;
}

.draft-remove-btn {
  color: #dc3545;
}

.draft-remove-btn:hover {
  background-color: #f8d7da;
}

.draft-details {
  font-size: 11px;
  color: #856404;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.draft-detail {
  display: flex;
  gap: 5px;
}

.draft-detail .detail-label {
  color: #856404;
  opacity: 0.8;
}

.draft-detail .detail-value {
  font-weight: 500;
}

.draft-notes {
  flex: 0 0 100%;
  margin-top: 5px;
  padding: 4px;
  background-color: #fff3cd;
  border-radius: 4px;
  font-style: italic;
  font-size: 10px;
}

.loading-drafts {
  text-align: center;
  padding: 20px;
  color: #856404;
  font-style: italic;
}


.required-star {
  color: #dc3545;
  margin-left: 2px;
  font-size: 14px;
}

.form-group .help-text {
  color: #6c757d;
  font-size: 12px;
  margin-top: 4px;
  font-style: italic;
}

.form-group input.error,
.form-group select.error {
  border-color: #dc3545;
  background-color: #fff8f8;
}

.error-message {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
}

.info-row.warning {
  background-color: #fff3cd;
  padding: 4px 8px;
  border-radius: 4px;
  margin: 5px 0;
}

.info-row.warning .info-label,
.info-row.warning .info-value {
  color: #856404;
}


.required-help {
  color: #6c757d;
  font-size: 12px;
  margin-top: 4px;
  font-style: italic;
}

.required-error {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  font-weight: 500;
  background-color: #f8d7da;
  padding: 4px 8px;
  border-radius: 4px;
  border-left: 3px solid #dc3545;
}

.help-text.range-help {
  color: #6c757d;
  font-size: 12px;
  margin-top: 4px;
  font-style: italic;
}


.form-group select {
  background-color: #fff;
  cursor: pointer;
}

.form-group select:focus {
  outline: none;
  border-color: #edec5b;
  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);
}

.form-group select.error {
  border-color: #dc3545;
  background-color: #fff8f8;
}


.required-star {
  color: #dc3545;
  margin-left: 2px;
  font-size: 14px;
}


.item-detail.price .detail-label,
.item-detail.sum .detail-label {
  font-weight: 600;
}

.item-detail.price .detail-value {
  font-weight: 600;
  color: #17a2b8;
}

.item-detail.sum .detail-value {
  font-weight: 600;
  color: #070707;
}


.confirm-dialog-line {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
}

.confirm-label {
  font-weight: 500;
  color: #666;
  text-align: left;
  flex: 1 1;
}

.confirm-value {
  font-weight: 600;
  color: #333;
  text-align: right;
  flex: 1 1;
  margin-left: 15px;
}

.confirm-dialog-line.full-width {
  justify-content: center;
  font-weight: 500;
  margin-bottom: 15px;
}

.confirm-dialog-buttons {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-top: 20px;
}

.confirm-dialog-buttons button {
  flex: 1 1;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.confirm-dialog-buttons .confirm-btn {
  background-color: #edec5b;
  color: #333;
}

.confirm-dialog-buttons .confirm-btn:hover {
  background-color: #f8f894;
}

.confirm-dialog-buttons .cancel-btn {
  background-color: #6c757d;
  color: white;
}

.confirm-dialog-buttons .cancel-btn:hover {
  background-color: #5a6268;
}


.item-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px dashed #f0f0f0;
}

.item-detail:last-child {
  border-bottom: none;
}

.detail-label {
  color: #666;
  font-size: 12px;
  font-weight: 500;
  flex: 1 1;
  text-align: left;
}

.detail-value {
  color: #333;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  margin-left: 15px;
  min-width: 80px;
}


.item-detail.price .detail-value,
.item-detail.sum .detail-value {
  color: #080808;
  font-weight: 700;
  font-size: 13px;
}

.item-detail.price .detail-label,
.item-detail.sum .detail-label {
  font-weight: 600;
}


.order-disclaimer {
  text-align: left;
}

.order-disclaimer p {
  text-align: left;
  margin: 5px 0;
}


.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.summary-row .price-value {
  font-weight: 600;
}


.current-item-info .info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px dashed #e9ecef;
}

.current-item-info .info-row:last-child {
  border-bottom: none;
}

.info-label {
  color: #666;
  font-size: 13px;
  font-weight: 500;
  flex: 1 1;
  text-align: left;
}

.info-value {
  color: #333;
  font-size: 13px;
  font-weight: 600;
  text-align: right;
  margin-left: 15px;
}


.item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dee2e6;
}

.item-system {
  font-weight: 600;
  color: #333;
  flex: 1 1;
  text-align: left;
  margin-left: 10px;
}


.required-star {
  color: #dc3545;
  margin-left: 4px;
  font-size: 14px;
}

.optional-star {
  color: #6c757d;
  margin-left: 4px;
  font-size: 11px;
  font-style: italic;
  font-weight: normal;
}

.error-message {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
}


.system-combobox {
  position: relative;
  width: 100%;
}

.system-combobox-input {
  width: 100%;
  padding: 10px 35px 10px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
  background-color: #fff;
}

.system-combobox-input:focus {
  outline: none;
  border-color: #edec5b;
  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);
}

.system-combobox-input.error {
  border-color: #dc3545;
  background-color: #fff8f8;
}

.system-combobox-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 12px;
  color: #6c757d;
  cursor: pointer;
  padding: 0 4px;
  transition: color 0.2s;
}

.system-combobox-btn:hover {
  color: #edec5b;
}

.system-combobox-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  margin-top: 4px;
}

.system-combobox-item {
  padding: 10px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.system-combobox-item:last-child {
  border-bottom: none;
}

.system-combobox-item:hover {
  background-color: #f8f9fa;
  color: #edec5b;
}

.system-combobox-item.selected {
  background-color: #edec5b20;
  color: #edec5b;
  font-weight: 500;
}


.color-combobox {
  position: relative;
  width: 100%;
}

.color-combobox-input {
  width: 100%;
  padding: 10px 35px 10px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
  background-color: #fff;
}

.color-combobox-input:focus {
  outline: none;
  border-color: #edec5b;
  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);
}

.color-combobox-input.error {
  border-color: #dc3545;
  background-color: #fff8f8;
}

.color-combobox-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 12px;
  color: #6c757d;
  cursor: pointer;
  padding: 0 4px;
}

.color-combobox-btn:hover {
  color: #edec5b;
}

.color-combobox-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  margin-top: 4px;
}

.color-combobox-item {
  padding: 10px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.color-combobox-item:last-child {
  border-bottom: none;
}

.color-combobox-item:hover {
  background-color: #f8f9fa;
  color: #edec5b;
}


.draft-items-list {
  margin-bottom: 20px;
  background-color: #fff8e7;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #ffc107;
}

.draft-items-list h3 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #856404;
}

.draft-items-container {
  max-height: 300px;
  overflow-y: auto;
}

.loading-drafts {
  text-align: center;
  padding: 20px;
  color: #856404;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/covfile/OrderPage.css"],"names":[],"mappings":";;;AAGA;;;;EAIE,gCAAgC;EAChC,oCAAoC;AACtC;;;AAGA;;EAEE,wBAAwB;AAC1B;;;AAGA;;;;;EAKE,wBAAwB;AAC1B;;;AAGA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;;AAGA;;EAEE,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;AACnC;;;AAGA;EACE,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;;AAGA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;;;AAIA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;;AAGA;EACE,SAAO;EACP,gBAAgB;AAClB;;;AAGA;EACE,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;;AAGA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;;;;EAIE,8BAA8B;AAChC;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;;AAGA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;;AAGA;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;;AAGA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;AACF;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,8FAA8F;IAC9F,yBAAyB;IACzB,iBAAiB;EACnB;;;EAGA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;;EAGA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,WAAS;EACX;;;EAGA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;;EAGA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,SAAO;EACT;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;;IAEE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;;EAGA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;;EAGA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,eAAe;EACjB;;;EAGA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;;EAGA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;;EAGA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;IAGE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;EACtB;;EAEA;;;IAGE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;;EAGA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;;EAGA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;;EAGA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;;EAGA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;;EAGA;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,cAAc;EAChB;;;EAGA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;EACzC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;;;EAGA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,yBAAyB;EAC3B;;EAEA;;;;IAIE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;;;IAGE,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;;;IAGE,qBAAqB;EACvB;;;EAGA;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,SAAO;IACT;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,sBAAsB;MACtB,SAAS;MACT,oBAAoB;IACtB;;IAEA;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,0BAA0B;IAC5B;EACF;EACA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,8BAA8B;EAChC;EACA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;;IAEE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;;IAEE,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;EAChB;;;AAGF;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;;AAGA;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2DAA2D;IAC3D,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;;AAIA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;AACnC;;;AAGA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;;AAGA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;;AAGA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;;AAGA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;AAGA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["\r\n\r\n\r\ninput.error,\r\nselect.error,\r\ntextarea.error,\r\n.system-combobox-input.error {\r\n  border-color: #dc3545 !important;\r\n  background-color: #fff8f8 !important;\r\n}\r\n\r\n\r\n.error-message:not(.range-error-message),\r\n.required-error {\r\n  display: none !important;\r\n}\r\n\r\n\r\n.error-message,\r\n.range-error-message,\r\n.required-error,\r\n[class*=\"error-message\"],\r\n[class*=\"range-error\"] {\r\n  display: none !important;\r\n}\r\n\r\n\r\n.range-error-message {\r\n  display: block !important;\r\n  color: #dc3545;\r\n  font-size: 12px;\r\n  margin-top: 5px;\r\n  font-weight: 500;\r\n  animation: fadeIn 0.3s ease;\r\n}\r\n\r\n\r\nlabel:has(+ input.error),\r\nlabel:has(+ select.error) {\r\n  color: #dc3545;\r\n}\r\n\r\n\r\n.required-star {\r\n  color: #dc3545;\r\n  margin-left: 3px;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-5px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n.summary-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 8px 0;\r\n  color: #666;\r\n}\r\n\r\n.summary-row.discount {\r\n  color: #0e0d0d;\r\n  font-weight: 600;\r\n}\r\n\r\n.summary-row.total {\r\n  margin-top: 8px;\r\n  padding-top: 12px;\r\n  border-top: 2px solid #dee2e6;\r\n  font-weight: 600;\r\n  color: #333;\r\n  font-size: 16px;\r\n}\r\n\r\n\r\n.summary-row:first-of-type {\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n.draft-items-list {\r\n  margin-bottom: 20px;\r\n  background-color: #fff8e7;\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  border: 1px solid #000000;\r\n}\r\n\r\n.draft-items-list h3 {\r\n  margin: 0 0 10px 0;\r\n  font-size: 14px;\r\n  color: #000000;\r\n}\r\n\r\n.draft-items-container {\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n\r\n\r\n.order-item-card.draft-item-card {\r\n  background-color: #fff8e7;\r\n  border: 1px solid #000000;\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  margin-bottom: 10px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.order-item-card.draft-item-card:hover {\r\n  border-color: #000000;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n\r\n.item-header.draft-item-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n  padding-bottom: 8px;\r\n  border-bottom: 1px dashed #000000;\r\n}\r\n\r\n\r\n.item-number.draft-number {\r\n  background-color: transparent;\r\n  color: #000000;\r\n  padding: 2px 8px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  margin-right: 10px;\r\n  border: 1px solid #000000;\r\n}\r\n\r\n\r\n.item-system.draft-system {\r\n  font-weight: 600;\r\n  color: #000000;\r\n  flex: 1;\r\n}\r\n\r\n\r\n.item-actions.draft-actions {\r\n  display: flex;\r\n  gap: 5px;\r\n}\r\n\r\n.item-edit-btn.draft-edit-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  padding: 2px 5px;\r\n  border-radius: 4px;\r\n  transition: all 0.2s;\r\n  color: #000000;\r\n}\r\n\r\n.item-edit-btn.draft-edit-btn:hover {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.item-remove-btn.draft-remove-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  padding: 2px 5px;\r\n  border-radius: 4px;\r\n  transition: all 0.2s;\r\n  color: #dc3545;\r\n}\r\n\r\n.item-remove-btn.draft-remove-btn:hover {\r\n  background-color: #f8d7da;\r\n}\r\n\r\n\r\n.draft-details {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.draft-details .item-details-left {\r\n  flex: 1;\r\n  min-width: 200px;\r\n}\r\n\r\n\r\n.draft-detail {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 4px 0;\r\n  border-bottom: none !important;\r\n}\r\n\r\n.draft-details .item-details-left .draft-detail {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n}\r\n\r\n.draft-details .item-details-left .detail-label {\r\n  width: 75px;\r\n  flex-shrink: 0;\r\n  color: #000000;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  text-align: left;\r\n}\r\n\r\n.draft-details .item-details-left .detail-value {\r\n  flex: 0 1 auto;\r\n  color: #000000;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-align: left;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n.item-notes.draft-notes {\r\n  flex: 0 0 100%;\r\n  margin-top: 8px;\r\n  padding: 6px;\r\n  background-color: #fff8e7;\r\n  border-radius: 4px;\r\n  color: #000000;\r\n  font-size: 11px;\r\n  font-style: italic;\r\n  border: 1px dashed #000000;\r\n}\r\n\r\n\r\n.loading-drafts {\r\n  text-align: center;\r\n  padding: 20px;\r\n  color: #000000;\r\n  font-style: italic;\r\n}\r\n\r\n\r\n\r\n.order-items-list {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.order-items-list h3 {\r\n  margin: 0 0 15px 0;\r\n  color: #080808;\r\n  font-size: 16px;\r\n}\r\n\r\n.no-items {\r\n  text-align: center;\r\n  padding: 30px;\r\n  color: #0c0c0c;\r\n  font-style: italic;\r\n  background-color: #f9f9f9;\r\n  border-radius: 8px;\r\n}\r\n\r\n.items-container {\r\n  max-height: 400px;\r\n  overflow-y: auto;\r\n  padding-right: 5px;\r\n}\r\n\r\n.items-container::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.items-container::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 10px;\r\n}\r\n\r\n.items-container::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n  border-radius: 10px;\r\n}\r\n\r\n.items-container::-webkit-scrollbar-thumb:hover {\r\n  background: #a8a8a8;\r\n}\r\n\r\n\r\n.order-item-card {\r\n  background-color: #f8f9fa;\r\n  border: 1px solid #e9ecef;\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  margin-bottom: 10px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.order-item-card:hover {\r\n  border-color: #edec5b;\r\n  box-shadow: 0 2px 4px rgba(108, 92, 231, 0.1);\r\n}\r\n\r\n.order-item-card.editing {\r\n  border: 2px solid #edec5b;\r\n  background-color: #f0ebff;\r\n}\r\n\r\n\r\n.item-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n  padding-bottom: 8px;\r\n  border-bottom: 1px dashed #dee2e6;\r\n}\r\n\r\n.item-number {\r\n  background-color: #edec5b;\r\n  color: rgb(7, 7, 7);\r\n  padding: 2px 8px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  margin-right: 10px;\r\n}\r\n\r\n.item-system {\r\n  font-weight: 600;\r\n  color: #333;\r\n  flex: 1;\r\n  font-size: 13px;\r\n}\r\n\r\n.item-actions {\r\n  display: flex;\r\n  gap: 5px;\r\n}\r\n\r\n.item-edit-btn, .item-remove-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  padding: 2px 5px;\r\n  border-radius: 4px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.item-edit-btn {\r\n  color: #edec5b;\r\n}\r\n\r\n.item-edit-btn:hover {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.item-remove-btn {\r\n  color: #dc3545;\r\n}\r\n\r\n.item-remove-btn:hover {\r\n  background-color: #f8d7da;\r\n}\r\n\r\n\r\n.item-details {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n\r\n.item-details-left {\r\n  flex: 1;\r\n  min-width: 180px;\r\n}\r\n\r\n\r\n.item-details-right {\r\n  flex-shrink: 0;\r\n  text-align: right;\r\n}\r\n\r\n\r\n.item-detail {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 3px 0;\r\n  border-bottom: none !important;\r\n}\r\n\r\n\r\n.item-details-left .item-detail {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n}\r\n\r\n.item-details-left .detail-label {\r\n  width: 85px;\r\n  flex-shrink: 0;\r\n  color: #080808;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  text-align: left;\r\n}\r\n\r\n.item-details-left .detail-value {\r\n  flex: 1;\r\n  color: #050505;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-align: left;\r\n  word-break: break-word;\r\n}\r\n\r\n\r\n.item-details-right .item-detail {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 3px 0;\r\n  border-bottom: none !important;\r\n}\r\n\r\n.item-details-right .detail-label {\r\n  color: #666;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  text-align: right;\r\n}\r\n\r\n.item-details-right .detail-value {\r\n  color: #080808;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  text-align: right;\r\n  min-width: 65px;\r\n}\r\n\r\n\r\n.item-detail.price .detail-value,\r\n.item-detail.sum .detail-value {\r\n  color: #080808;\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n}\r\n\r\n.item-detail.price .detail-label,\r\n.item-detail.sum .detail-label {\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n}\r\n\r\n\r\n.item-detail,\r\n.item-detail:last-child,\r\n.item-details-left .item-detail,\r\n.item-details-right .item-detail {\r\n  border-bottom: none !important;\r\n}\r\n\r\n\r\n.item-notes {\r\n  flex: 0 0 100%;\r\n  margin-top: 8px;\r\n  padding: 6px;\r\n  background-color: #fff3cd;\r\n  border-radius: 4px;\r\n  color: #856404;\r\n  font-size: 11px;\r\n  font-style: italic;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .item-details {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .item-details-left {\r\n    width: 100%;\r\n  }\r\n  \r\n  .item-details-right {\r\n    width: 100%;\r\n  }\r\n  \r\n  .item-details-right .item-detail {\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  .item-details-right .detail-label {\r\n    text-align: left;\r\n  }\r\n  \r\n  .item-details-right .detail-value {\r\n    text-align: right;\r\n  }\r\n}\r\n\r\n\r\n.item-details {\r\n  display: flex;\r\n  gap: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.item-details-left {\r\n  flex: 2;\r\n  min-width: 200px;\r\n}\r\n\r\n.item-details-right {\r\n  flex: 1;\r\n  min-width: 180px;\r\n}\r\n\r\n\r\n.item-detail {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 6px 0;\r\n  border-bottom: 1px dashed #f0f0f0;\r\n  gap: 10px;\r\n}\r\n\r\n.item-detail:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.detail-label {\r\n  color: #666;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  flex-shrink: 0;\r\n  text-align: left;\r\n}\r\n\r\n.detail-value {\r\n  color: #333;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  text-align: right;\r\n  flex-shrink: 0;\r\n}\r\n\r\n\r\n.item-details-right .item-detail {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.item-details-right .detail-label {\r\n  text-align: left;\r\n  flex: 1;\r\n  white-space: normal;\r\n  word-wrap: break-word;\r\n  line-height: 1.4;\r\n}\r\n\r\n.item-details-right .detail-value {\r\n  text-align: right;\r\n  flex-shrink: 0;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n.item-detail.price .detail-value,\r\n.item-detail.sum .detail-value {\r\n  color: #080808;\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n}\r\n\r\n.item-detail.price .detail-label,\r\n.item-detail.sum .detail-label {\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .item-details {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .item-details-left,\r\n  .item-details-right {\r\n    min-width: 100%;\r\n  }\r\n  \r\n  .item-details-right .item-detail {\r\n    justify-content: space-between;\r\n    align-items: center;\r\n  }\r\n  \r\n  .item-details-right .detail-label {\r\n    flex: 1;\r\n  }\r\n}\r\n.order-page {\r\n    padding: 20px;\r\n    max-width: 1600px;\r\n    margin: 0 auto;\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;\r\n    background-color: #f5f5f5;\r\n    min-height: 100vh;\r\n  }\r\n  \r\n  \r\n  .order-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 30px;\r\n    padding: 15px 20px;\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .header-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .my-orders-btn {\r\n    padding: 10px 20px;\r\n    background-color: #edec5b;\r\n    color: rgb(0, 0, 0);\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .my-orders-btn:hover {\r\n    background-color: #f8f894;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 8px rgba(108, 92, 231, 0.3);\r\n  }\r\n  \r\n  .dealer-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .dealer-label {\r\n    color: #666;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .dealer-name {\r\n    font-weight: 600;\r\n    color: #333;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .save-draft-btn {\r\n    padding: 10px 25px;\r\n    background-color: #edec5b;\r\n    color: #333;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .save-draft-btn:hover:not(:disabled) {\r\n    background-color: #ffb300;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 8px rgba(255, 193, 7, 0.3);\r\n  }\r\n  \r\n  .save-draft-btn:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  \r\n  .order-content {\r\n    display: flex;\r\n    gap: 30px;\r\n  }\r\n  \r\n  .left-column {\r\n    flex: 2;\r\n  }\r\n  \r\n  .right-column {\r\n    flex: 1.2;\r\n  }\r\n  \r\n  \r\n  .order-info-card {\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    padding: 20px;\r\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n    position: sticky;\r\n    top: 20px;\r\n  }\r\n  \r\n  .order-number-header {\r\n    margin-bottom: 20px;\r\n    padding-bottom: 15px;\r\n    border-bottom: 2px solid #f0f0f0;\r\n  }\r\n  \r\n  .order-number-header h2 {\r\n    margin: 0;\r\n    color: #333;\r\n    font-size: 20px;\r\n  }\r\n  \r\n  \r\n  .order-items-list {\r\n    margin-bottom: 25px;\r\n  }\r\n  \r\n  .order-items-list h3 {\r\n    margin: 0 0 15px 0;\r\n    color: #080808;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .no-items {\r\n    text-align: center;\r\n    padding: 30px;\r\n    color: #0c0c0c;\r\n    font-style: italic;\r\n    background-color: #f9f9f9;\r\n    border-radius: 8px;\r\n  }\r\n  \r\n  .items-container {\r\n    max-height: 400px;\r\n    overflow-y: auto;\r\n    padding-right: 5px;\r\n  }\r\n  \r\n  .items-container::-webkit-scrollbar {\r\n    width: 6px;\r\n  }\r\n  \r\n  .items-container::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  .items-container::-webkit-scrollbar-thumb {\r\n    background: #c1c1c1;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  .items-container::-webkit-scrollbar-thumb:hover {\r\n    background: #a8a8a8;\r\n  }\r\n  \r\n  .order-item-card {\r\n    background-color: #f8f9fa;\r\n    border: 1px solid #e9ecef;\r\n    border-radius: 8px;\r\n    padding: 12px;\r\n    margin-bottom: 10px;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .order-item-card:hover {\r\n    border-color: #edec5b;\r\n    box-shadow: 0 2px 4px rgba(108, 92, 231, 0.1);\r\n  }\r\n  \r\n  .order-item-card.editing {\r\n    border: 2px solid #edec5b;\r\n    background-color: #f0ebff;\r\n  }\r\n  \r\n  .item-header {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n    padding-bottom: 8px;\r\n    border-bottom: 1px dashed #dee2e6;\r\n  }\r\n  \r\n  .item-number {\r\n    background-color: #edec5b;\r\n    color: rgb(7, 7, 7);\r\n    padding: 2px 8px;\r\n    border-radius: 12px;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  .item-system {\r\n    font-weight: 600;\r\n    color: #333;\r\n    flex: 1;\r\n  }\r\n  \r\n  .item-actions {\r\n    display: flex;\r\n    gap: 5px;\r\n  }\r\n  \r\n  .item-edit-btn, .item-remove-btn {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    padding: 2px 5px;\r\n    border-radius: 4px;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .item-edit-btn {\r\n    color: #edec5b;\r\n  }\r\n  \r\n  .item-edit-btn:hover {\r\n    background-color: #e9ecef;\r\n  }\r\n  \r\n  .item-remove-btn {\r\n    color: #dc3545;\r\n  }\r\n  \r\n  .item-remove-btn:hover {\r\n    background-color: #f8d7da;\r\n  }\r\n  \r\n  .item-details {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    font-size: 13px;\r\n  }\r\n  \r\n  .item-detail {\r\n    flex: 1 1 calc(50% - 5px);\r\n    display: flex;\r\n    justify-content: space-between;\r\n    color: #666;\r\n  }\r\n  \r\n  .item-detail .detail-label {\r\n    color: #0c0c0c;\r\n  }\r\n  \r\n  .item-detail .detail-value {\r\n    font-weight: 500;\r\n    color: #333;\r\n  }\r\n  \r\n  .item-detail.price .detail-value,\r\n  .item-detail.sum .detail-value {\r\n    font-weight: 600;\r\n    color: #030303;\r\n  }\r\n  \r\n  .item-notes {\r\n    flex: 0 0 100%;\r\n    margin-top: 8px;\r\n    padding: 6px;\r\n    background-color: #fff3cd;\r\n    border-radius: 4px;\r\n    color: #856404;\r\n    font-size: 12px;\r\n    font-style: italic;\r\n  }\r\n  \r\n  \r\n  .order-summary {\r\n    background-color: #f8f9fa;\r\n    border-radius: 8px;\r\n    padding: 15px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .order-summary h3 {\r\n    margin: 0 0 15px 0;\r\n    color: #333;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .summary-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 8px 0;\r\n    color: #666;\r\n  }\r\n  \r\n  .summary-row.discount {\r\n    color: #0e0d0d;\r\n  }\r\n  \r\n  .summary-row.total {\r\n    margin-top: 8px;\r\n    padding-top: 12px;\r\n    border-top: 2px solid #dee2e6;\r\n    font-weight: 600;\r\n    color: #333;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  \r\n  .order-disclaimer {\r\n    background-color: #fff3cd;\r\n    border-left: 4px solid #ffc107;\r\n    padding: 12px 15px;\r\n    margin-bottom: 20px;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .order-disclaimer p {\r\n    margin: 5px 0;\r\n    color: #856404;\r\n    font-size: 13px;\r\n  }\r\n  \r\n  \r\n  .order-notes {\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .order-notes h3 {\r\n    margin: 0 0 10px 0;\r\n    color: #080808;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .order-notes textarea {\r\n    width: 100%;\r\n    padding: 12px;\r\n    border: 1px solid #b5babd;\r\n    color: #000000;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    resize: vertical;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .order-notes textarea:focus {\r\n    outline: none;\r\n    border-color: #edec5b;\r\n    box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);\r\n  }\r\n  \r\n  \r\n  .confirm-order-btn {\r\n    width: 100%;\r\n    padding: 15px;\r\n    background-color: #4a4542;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .confirm-order-btn:hover:not(:disabled) {\r\n    background-color: #5f5d5c;\r\n    transform: translateY(-2px);\r\n    box-shadow: #5f5d5c;\r\n  }\r\n  \r\n  .confirm-order-btn:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  \r\n  .form-section {\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    padding: 25px;\r\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n    margin-bottom: 0;\r\n  }\r\n  \r\n  .form-section h3 {\r\n    margin-top: 0;\r\n    margin-bottom: 20px;\r\n    color: #333;\r\n    font-size: 18px;\r\n  }\r\n  \r\n  .form-row {\r\n    display: flex;\r\n    gap: 15px;\r\n    margin-bottom: 15px;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .form-group {\r\n    flex: 1;\r\n    min-width: 200px;\r\n  }\r\n  \r\n  .form-group label {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n    color: #080808;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .form-group input,\r\n  .form-group select,\r\n  .form-group textarea {\r\n    width: 100%;\r\n    padding: 10px 12px;\r\n    border: 1px solid #dee2e6;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .form-group input:focus,\r\n  .form-group select:focus,\r\n  .form-group textarea:focus {\r\n    outline: none;\r\n    border-color: #edec5b;\r\n    box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);\r\n  }\r\n  \r\n  .form-group input.error,\r\n  .form-group select.error {\r\n    border-color: #dc3545;\r\n  }\r\n  \r\n  .error-message {\r\n    color: #dc3545;\r\n    font-size: 12px;\r\n    margin-top: 4px;\r\n  }\r\n  \r\n  .help-text {\r\n    color: #6c757d;\r\n    font-size: 12px;\r\n    margin-top: 4px;\r\n    font-style: italic;\r\n  }\r\n  \r\n  \r\n  .required-star {\r\n    color: #dc3545;\r\n    margin-left: 2px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .optional-star {\r\n    color: #6c757d;\r\n    margin-left: 4px;\r\n    font-size: 11px;\r\n    font-style: italic;\r\n    font-weight: normal;\r\n  }\r\n  \r\n  \r\n  .user-discount-info {\r\n    background-color: #e7f5ff;\r\n    border-left: 4px solid #edec5b;\r\n    padding: 12px 15px;\r\n    margin-bottom: 20px;\r\n    border-radius: 4px;\r\n    color: #070707;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .user-discount-info strong {\r\n    color: #edec5b;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  \r\n  .system-type-info {\r\n    background-color: #f8f9fa;\r\n    padding: 10px 15px;\r\n    margin-bottom: 20px;\r\n    border-radius: 6px;\r\n    color: #080808;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .system-type-info strong {\r\n    color: #edec5b;\r\n  }\r\n  \r\n  \r\n  .price-type-info {\r\n    background-color: #fff3cd;\r\n    border-left: 4px solid #ffc107;\r\n    padding: 10px 15px;\r\n    margin-bottom: 20px;\r\n    border-radius: 4px;\r\n    color: #856404;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  \r\n  .price-loading {\r\n    background-color: #e7f5ff;\r\n    padding: 15px;\r\n    border-radius: 6px;\r\n    margin: 15px 0;\r\n    text-align: center;\r\n    color: #edec5b;\r\n    font-style: italic;\r\n  }\r\n  \r\n  .price-result {\r\n    background-color: #d4edda;\r\n    border: 1px solid #c3e6cb;\r\n    border-radius: 6px;\r\n    padding: 15px;\r\n    margin: 15px 0;\r\n  }\r\n  \r\n  .price-result p {\r\n    margin: 8px 0;\r\n    color: #155724;\r\n  }\r\n  \r\n  .price-result .discount {\r\n    background-color: #fff3cd;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    display: inline-block;\r\n    color: #856404;\r\n    font-size: 13px;\r\n  }\r\n  \r\n  .price-result .final-price {\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    margin-top: 10px;\r\n    padding-top: 10px;\r\n    border-top: 1px solid #c3e6cb;\r\n  }\r\n  \r\n  .price-result .final-price strong {\r\n    color: #030303;\r\n    font-size: 18px;\r\n  }\r\n  \r\n  .price-error {\r\n    background-color: #f8d7da;\r\n    border: 1px solid #f5c6cb;\r\n    border-radius: 6px;\r\n    padding: 15px;\r\n    margin: 15px 0;\r\n    color: #721c24;\r\n  }\r\n  \r\n  \r\n  .form-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-top: 20px;\r\n  }\r\n  \r\n  .add-item-btn {\r\n    flex: 2;\r\n    padding: 12px;\r\n    background-color: #edec5b;\r\n    color: rgb(0, 0, 0);\r\n    border: none;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .add-item-btn:hover:not(:disabled) {\r\n    background-color: #f8f894;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 8px rgba(201, 231, 92, 0.3);\r\n  }\r\n  \r\n  .add-item-btn:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .cancel-edit-btn {\r\n    flex: 1;\r\n    padding: 12px;\r\n    background-color: #6c757d;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .cancel-edit-btn:hover {\r\n    background-color: #5a6268;\r\n  }\r\n  \r\n  \r\n  .orders-list-modal {\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    padding: 25px;\r\n    margin-bottom: 30px;\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n  }\r\n  \r\n  .orders-list-modal h2 {\r\n    margin-top: 0;\r\n    margin-bottom: 20px;\r\n    color: #333;\r\n    font-size: 20px;\r\n  }\r\n  \r\n  .orders-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n    gap: 20px;\r\n  }\r\n  \r\n  .order-card {\r\n    border: 1px solid #e9ecef;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .order-card:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .order-card.draft {\r\n    border-left: 4px solid #ffc107;\r\n  }\r\n  \r\n  .order-card.confirmed {\r\n    border-left: 4px solid #080808;\r\n  }\r\n  \r\n  .order-card.archived {\r\n    border-left: 4px solid #6c757d;\r\n    opacity: 0.8;\r\n  }\r\n  \r\n  .order-card-header {\r\n    background-color: #f8f9fa;\r\n    padding: 12px 15px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-bottom: 1px solid #e9ecef;\r\n  }\r\n  \r\n  .order-number {\r\n    font-weight: 600;\r\n    color: #333;\r\n  }\r\n  \r\n  .order-status {\r\n    font-size: 12px;\r\n    padding: 3px 8px;\r\n    border-radius: 12px;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .order-status.draft {\r\n    background-color: #fff3cd;\r\n    color: #856404;\r\n  }\r\n  \r\n  .order-status.confirmed {\r\n    background-color: #d4edda;\r\n    color: #155724;\r\n  }\r\n  \r\n  .order-status.archived {\r\n    background-color: #e2e3e5;\r\n    color: #383d41;\r\n  }\r\n  \r\n  .order-card-body {\r\n    padding: 15px;\r\n    background-color: #dcdcda;\r\n  }\r\n  \r\n  .order-card-body div {\r\n    margin-bottom: 6px;\r\n    color: #080808;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .order-card-actions {\r\n    padding: 12px 15px;\r\n    display: flex;\r\n    gap: 8px;\r\n    border-top: 1px solid #e9ecef;\r\n    background-color: #dcdcda;\r\n  }\r\n  \r\n  .order-card-actions button {\r\n    flex: 1;\r\n    padding: 6px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .order-card-actions button:first-child {\r\n    background-color: #edec5b;\r\n    color: rgb(0, 0, 0);\r\n  }\r\n  \r\n  .order-card-actions button:nth-child(2) {\r\n    background-color: #070707;\r\n    color: white;\r\n  }\r\n  \r\n  .order-card-actions button:last-child {\r\n    background-color: #ffc107;\r\n    color: #333;\r\n  }\r\n  \r\n  .order-card-actions button:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .no-orders {\r\n    text-align: center;\r\n    padding: 40px;\r\n    color: #6c757d;\r\n    font-style: italic;\r\n  }\r\n  \r\n  \r\n  .confirm-dialog-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1100;\r\n  }\r\n  \r\n  .confirm-dialog {\r\n    background-color: white;\r\n    padding: 25px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\r\n    max-width: 400px;\r\n    width: 90%;\r\n  }\r\n  \r\n  .confirm-dialog p {\r\n    margin: 0 0 20px 0;\r\n    font-size: 16px;\r\n    color: #333;\r\n  }\r\n  \r\n  .confirm-dialog-buttons {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .confirm-dialog-buttons button {\r\n    padding: 8px 20px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .confirm-btn {\r\n    background-color: #dc3545;\r\n    color: white;\r\n  }\r\n  \r\n  .confirm-btn:hover {\r\n    background-color: #c82333;\r\n  }\r\n  \r\n  .cancel-btn {\r\n    background-color: #6c757d;\r\n    color: white;\r\n  }\r\n  \r\n  .cancel-btn:hover {\r\n    background-color: #5a6268;\r\n  }\r\n  \r\n  \r\n  .dark-theme .order-page {\r\n    background-color: #ffffff;\r\n  }\r\n  \r\n  .dark-theme .order-header,\r\n  .dark-theme .form-section,\r\n  .dark-theme .order-info-card,\r\n  .dark-theme .orders-list-modal {\r\n    background-color: #dcdcda;\r\n    border-color: #404040;\r\n  }\r\n  \r\n  .dark-theme .dealer-label {\r\n    color: #000000;\r\n  }\r\n  \r\n  .dark-theme .dealer-name {\r\n    color: #000000;\r\n  }\r\n  \r\n  .dark-theme .order-number-header h2 {\r\n    color: #000000;\r\n  }\r\n  \r\n  .dark-theme .order-item-card {\r\n    background-color: #b5babd;\r\n    border-color: #404040;\r\n  }\r\n  \r\n  .dark-theme .item-system {\r\n    color: #000000;\r\n  }\r\n  \r\n  .dark-theme .item-detail {\r\n    color: #000000;\r\n  }\r\n  \r\n  .dark-theme .item-detail .detail-value {\r\n    color: #000000;\r\n  }\r\n  \r\n  .dark-theme .order-summary {\r\n    background-color: #b5babd;\r\n  }\r\n  \r\n  .dark-theme .form-group label {\r\n    color: #000000;\r\n  }\r\n  \r\n  .dark-theme .form-group input,\r\n  .dark-theme .form-group select,\r\n  .dark-theme .form-group textarea {\r\n    background-color: #b5babd;\r\n    border-color: #080808;\r\n    color: #030303;\r\n  }\r\n  \r\n  .dark-theme .form-group input:focus,\r\n  .dark-theme .form-group select:focus,\r\n  .dark-theme .form-group textarea:focus {\r\n    border-color: #edec5b;\r\n  }\r\n  \r\n  \r\n  @media (max-width: 1200px) {\r\n    .order-content {\r\n      flex-direction: column;\r\n    }\r\n    \r\n    .right-column {\r\n      flex: 1;\r\n    }\r\n    \r\n    .order-info-card {\r\n      position: static;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .order-header {\r\n      flex-direction: column;\r\n      gap: 15px;\r\n      align-items: stretch;\r\n    }\r\n    \r\n    .header-left {\r\n      flex-direction: column;\r\n      gap: 10px;\r\n    }\r\n    \r\n    .form-row {\r\n      flex-direction: column;\r\n      gap: 10px;\r\n    }\r\n    \r\n    .form-group {\r\n      min-width: 100%;\r\n    }\r\n    \r\n    .form-actions {\r\n      flex-direction: column;\r\n    }\r\n    \r\n    .orders-grid {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n  .current-price-result {\r\n    background-color: #e8f4fd;\r\n    border: 1px solid #b8e0ff;\r\n    border-radius: 8px;\r\n    padding: 15px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .current-price-result h3 {\r\n    margin: 0 0 10px 0;\r\n    font-size: 16px;\r\n    color: #0066cc;\r\n  }\r\n  \r\n  .price-result-compact p {\r\n    margin: 5px 0;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .price-result-compact .final-price {\r\n    font-weight: bold;\r\n    color: #070707;\r\n    font-size: 16px;\r\n    margin-top: 8px;\r\n    padding-top: 8px;\r\n    border-top: 1px dashed #b8e0ff;\r\n  }\r\n  .range-error-message {\r\n    color: #dc3545;\r\n    font-size: 12px;\r\n    margin-top: 4px;\r\n    font-weight: 500;\r\n    background-color: #f8d7da;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    border-left: 3px solid #dc3545;\r\n  }\r\n  \r\n  .form-group input.error,\r\n  .form-group select.error {\r\n    border-color: #dc3545;\r\n    background-color: #fff8f8;\r\n  }\r\n  \r\n  .form-group input.error:focus,\r\n  .form-group select.error:focus {\r\n    border-color: #dc3545;\r\n    box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\r\n  }\r\n  \r\n  .current-price-result {\r\n    background-color: #e8f4fd;\r\n    border: 1px solid #b8e0ff;\r\n    border-radius: 8px;\r\n    padding: 15px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .current-price-result h3 {\r\n    margin: 0 0 10px 0;\r\n    font-size: 16px;\r\n    color: #0066cc;\r\n  }\r\n  \r\n  .price-result-compact p {\r\n    margin: 5px 0;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .price-result-compact .final-price {\r\n    font-weight: bold;\r\n    color: #030303;\r\n    font-size: 16px;\r\n    margin-top: 8px;\r\n    padding-top: 8px;\r\n    border-top: 1px dashed #b8e0ff;\r\n  }\r\n  \r\n  .add-item-btn:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n    background-color: #585756;\r\n  }\r\n\r\n  .current-price-result {\r\n    background-color: #f8f9fa;\r\n    border: 1px solid #dee2e6;\r\n    border-radius: 8px;\r\n    padding: 15px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .current-price-result h3 {\r\n    margin: 0 0 15px 0;\r\n    font-size: 16px;\r\n    color: #050505;\r\n    border-bottom: 1px solid #dee2e6;\r\n    padding-bottom: 10px;\r\n  }\r\n  \r\n  .current-item-info {\r\n    margin-bottom: 15px;\r\n    padding-bottom: 15px;\r\n    border-bottom: 1px dashed #dee2e6;\r\n  }\r\n  \r\n  .info-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-bottom: 8px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .info-label {\r\n    color: #050505;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .info-value {\r\n    color: #212529;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .price-calculation {\r\n    background-color: white;\r\n    border-radius: 6px;\r\n    padding: 10px;\r\n  }\r\n  \r\n  .summary-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 8px 0;\r\n    color: #050505;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .summary-row.discount {\r\n    color: #070707;\r\n  }\r\n  \r\n  .summary-row.total {\r\n    margin-top: 8px;\r\n    padding-top: 12px;\r\n    border-top: 2px solid #dee2e6;\r\n    font-weight: 600;\r\n    color: #030303;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .summary-row.price-per-unit {\r\n    margin-top: 5px;\r\n    padding-top: 5px;\r\n    border-top: 1px dashed #dee2e6;\r\n    font-style: italic;\r\n    color: #050505;\r\n  }\r\n\r\n  \r\n.fabric-code-group {\r\n  position: relative;\r\n}\r\n\r\n.fabric-code-input {\r\n  display: flex;\r\n  gap: 5px;\r\n}\r\n\r\n.fabric-code-input input {\r\n  flex: 1;\r\n}\r\n\r\n.fabric-select-btn {\r\n  width: 40px;\r\n  background-color: #edec5b;\r\n  color: rgb(0, 0, 0);\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.fabric-select-btn:hover {\r\n  background-color: #f8f894;\r\n}\r\n\r\n.selected-fabric-info {\r\n  margin-top: 5px;\r\n  font-size: 12px;\r\n  color: #6c757d;\r\n  font-style: italic;\r\n}\r\n\r\n\r\n.fabric-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 2000;\r\n  animation: fadeIn 0.2s ease;\r\n}\r\n\r\n.fabric-modal {\r\n  background-color: white;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 1000px;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\r\n  animation: slideUp 0.3s ease;\r\n}\r\n\r\n.fabric-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 15px 20px;\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.fabric-modal-header h2 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 18px;\r\n}\r\n\r\n.close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  color: #0c0c0c;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.close-btn:hover {\r\n  color: #dc3545;\r\n}\r\n\r\n.fabric-search {\r\n  padding: 12px 20px;\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.fabric-search input {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.fabric-search input:focus {\r\n  outline: none;\r\n  border-color: #edec5b;\r\n}\r\n\r\n.fabric-grid-container {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 15px;\r\n  max-height: 60vh;\r\n}\r\n\r\n.fabric-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.fabric-item {\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  background-color: white;\r\n}\r\n\r\n.fabric-item:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  border-color: #edec5b;\r\n}\r\n\r\n.fabric-item.selected {\r\n  border-color: #edec5b;\r\n  background-color: #f0ebff;\r\n  box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2);\r\n}\r\n\r\n.fabric-image {\r\n  height: 100px;\r\n  overflow: hidden;\r\n  background-color: #f8f9fa;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.fabric-image img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.fabric-info {\r\n  padding: 8px;\r\n  text-align: center;\r\n}\r\n\r\n.fabric-code {\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 2px;\r\n  font-size: 12px;\r\n}\r\n\r\n.fabric-price-group {\r\n  color: #070707;\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n}\r\n\r\n.no-image {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #6c757d;\r\n  font-size: 11px;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.loading-fabrics {\r\n  text-align: center;\r\n  padding: 30px;\r\n  color: #6c757d;\r\n  font-size: 14px;\r\n  font-style: italic;\r\n}\r\n\r\n.fabric-modal-footer {\r\n  padding: 12px 20px;\r\n  border-top: 1px solid #dee2e6;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n}\r\n\r\n.fabric-modal-footer .cancel-btn {\r\n  padding: 8px 16px;\r\n  background-color: #6c757d;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.fabric-modal-footer .cancel-btn:hover {\r\n  background-color: #5a6268;\r\n}\r\n\r\n.fabric-modal-footer .confirm-btn {\r\n  padding: 8px 24px;\r\n  background-color: #edec5b;\r\n  color: rgb(0, 0, 0);\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.fabric-modal-footer .confirm-btn:hover:not(:disabled) {\r\n  background-color: #f8f894;\r\n}\r\n\r\n.fabric-modal-footer .confirm-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    transform: translateY(30px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .fabric-grid {\r\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\r\n    gap: 10px;\r\n  }\r\n  \r\n  .fabric-image {\r\n    height: 80px;\r\n  }\r\n  \r\n  .fabric-code {\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .fabric-grid {\r\n    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\r\n    gap: 8px;\r\n  }\r\n  \r\n  .fabric-image {\r\n    height: 70px;\r\n  }\r\n  \r\n  .fabric-code {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n.fabric-type {\r\n  color: #6c757d;\r\n  font-size: 12px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.fabric-price-group {\r\n  color: #0a0a0a;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.loading-fabrics {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #6c757d;\r\n  font-size: 16px;\r\n  font-style: italic;\r\n}\r\n\r\n.fabric-modal-footer {\r\n  padding: 20px 25px;\r\n  border-top: 1px solid #dee2e6;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n}\r\n\r\n.fabric-modal-footer .cancel-btn {\r\n  padding: 10px 20px;\r\n  background-color: #6c757d;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.fabric-modal-footer .cancel-btn:hover {\r\n  background-color: #5a6268;\r\n}\r\n\r\n.fabric-modal-footer .confirm-btn {\r\n  padding: 10px 30px;\r\n  background-color: #edec5b;\r\n  color: rgb(0, 0, 0);\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.fabric-modal-footer .confirm-btn:hover:not(:disabled) {\r\n  background-color: #f8f894;\r\n}\r\n\r\n.fabric-modal-footer .confirm-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    transform: translateY(50px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n\r\n.dark-theme .fabric-modal {\r\n  background-color: #dcdcda;\r\n}\r\n\r\n.dark-theme .fabric-modal-header {\r\n  border-bottom-color: #404040;\r\n}\r\n\r\n.dark-theme .fabric-modal-header h2 {\r\n  color: #020202;\r\n}\r\n\r\n.dark-theme .fabric-search {\r\n  border-bottom-color: #404040;\r\n}\r\n\r\n.dark-theme .fabric-search input {\r\n  background-color: #b5babd;\r\n  border-color: #080808;\r\n  color: #020202;\r\n}\r\n\r\n.dark-theme .fabric-item {\r\n  background-color: #b5babd;\r\n  border-color: #404040;\r\n}\r\n\r\n.dark-theme .fabric-item.selected {\r\n  background-color: #edec5b;\r\n  border-color: #edec5b;\r\n}\r\n\r\n.dark-theme .fabric-code {\r\n  color: #020202;\r\n}\r\n\r\n.dark-theme .fabric-type {\r\n  color: #b0b0b0;\r\n}\r\n\r\n.dark-theme .fabric-modal-footer {\r\n  border-top-color: #404040;\r\n}\r\n\r\n\r\n.system-combobox {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.system-combobox-input {\r\n  width: 100%;\r\n  padding: 10px 35px 10px 12px;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  transition: all 0.2s;\r\n  background-color: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n.system-combobox-input:focus {\r\n  outline: none;\r\n  border-color: #edec5b;\r\n  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);\r\n}\r\n\r\n.system-combobox-input.error {\r\n  border-color: #dc3545;\r\n}\r\n\r\n.system-combobox-btn {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  font-size: 12px;\r\n  color: #6c757d;\r\n  cursor: pointer;\r\n  padding: 0 4px;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.system-combobox-btn:hover {\r\n  color: #edec5b;\r\n}\r\n\r\n.system-combobox-dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  max-height: 250px;\r\n  overflow-y: auto;\r\n  background-color: white;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  z-index: 1000;\r\n  margin-top: 4px;\r\n}\r\n\r\n.system-combobox-item {\r\n  padding: 10px 12px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  font-size: 14px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.system-combobox-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.system-combobox-item:hover {\r\n  background-color: #f8f9fa;\r\n  color: #edec5b;\r\n}\r\n\r\n.system-combobox-item.selected {\r\n  background-color: #edec5b20;\r\n  color: #edec5b;\r\n  font-weight: 500;\r\n}\r\n\r\n\r\n.dark-theme .system-combobox-input {\r\n  background-color: #b5babd;\r\n  border-color: #404040;\r\n  color: #030303;\r\n}\r\n\r\n.dark-theme .system-combobox-input:focus {\r\n  border-color: #edec5b;\r\n}\r\n\r\n.dark-theme .system-combobox-btn {\r\n  color: #a0a0a0;\r\n}\r\n\r\n.dark-theme .system-combobox-btn:hover {\r\n  color: #edec5b;\r\n}\r\n\r\n.dark-theme .system-combobox-dropdown {\r\n  background-color: #2d2d2d;\r\n  border-color: #404040;\r\n}\r\n\r\n.dark-theme .system-combobox-item {\r\n  color: #e0e0e0;\r\n  border-bottom-color: #404040;\r\n}\r\n\r\n.dark-theme .system-combobox-item:hover {\r\n  background-color: #3d3d3d;\r\n  color: #edec5b;\r\n}\r\n\r\n.system-combobox {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.system-combobox-input {\r\n  width: 100%;\r\n  padding: 10px 35px 10px 12px;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  transition: all 0.2s;\r\n  background-color: #fff;\r\n}\r\n\r\n.system-combobox-input:focus {\r\n  outline: none;\r\n  border-color: #edec5b;\r\n  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);\r\n}\r\n\r\n.system-combobox-input.error {\r\n  border-color: #dc3545;\r\n}\r\n\r\n.system-combobox-btn {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  font-size: 12px;\r\n  color: #6c757d;\r\n  cursor: pointer;\r\n  padding: 0 4px;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.system-combobox-btn:hover {\r\n  color: #edec5b;\r\n}\r\n\r\n.system-combobox-dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  max-height: 250px;\r\n  overflow-y: auto;\r\n  background-color: white;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  z-index: 1000;\r\n  margin-top: 4px;\r\n}\r\n\r\n.system-combobox-item {\r\n  padding: 10px 12px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  font-size: 14px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.system-combobox-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.system-combobox-item:hover {\r\n  background-color: #f8f9fa;\r\n  color: #edec5b;\r\n}\r\n\r\n.system-combobox-item.selected {\r\n  background-color: #edec5b20;\r\n  color: #edec5b;\r\n  font-weight: 500;\r\n}\r\n\r\n\r\n.form-row.full-width {\r\n  width: 100%;\r\n}\r\n\r\n.form-group.full-width {\r\n  width: 100%;\r\n}\r\n\r\n\r\n.dark-theme .system-combobox-input {\r\n  background-color: #b5babd;\r\n  border-color: #404040;\r\n  color: #030303;\r\n}\r\n\r\n.dark-theme .system-combobox-input:focus {\r\n  border-color: #edec5b;\r\n}\r\n\r\n.dark-theme .system-combobox-btn {\r\n  color: #a0a0a0;\r\n}\r\n\r\n.dark-theme .system-combobox-btn:hover {\r\n  color: #edec5b;\r\n}\r\n\r\n.dark-theme .system-combobox-dropdown {\r\n  background-color: #2d2d2d;\r\n  border-color: #404040;\r\n}\r\n\r\n.dark-theme .system-combobox-item {\r\n  color: #e0e0e0;\r\n  border-bottom-color: #404040;\r\n}\r\n\r\n.dark-theme .system-combobox-item:hover {\r\n  background-color: #3d3d3d;\r\n  color: #edec5b;\r\n}\r\n\r\n.text-left {\r\n  text-align: left !important;\r\n}\r\n\r\n.form-group label {\r\n  text-align: left;\r\n  display: block;\r\n}\r\n\r\n.save-draft-item-btn {\r\n  flex: 1;\r\n  padding: 12px;\r\n  background-color: #6c757d;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.save-draft-item-btn:hover:not(:disabled) {\r\n  background-color: #5a6268;\r\n}\r\n\r\n.save-draft-item-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n\r\n\r\n.draft-items-list {\r\n  margin-bottom: 20px;\r\n  background-color: #fff8e7;\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  border: 1px solid #000000;\r\n}\r\n\r\n.draft-items-list h3 {\r\n  margin: 0 0 10px 0;\r\n  font-size: 14px;\r\n  color: #000000;\r\n}\r\n\r\n.draft-items-container {\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n\r\n\r\n.order-item-card.draft-item-card {\r\n  background-color: #fff8e7;\r\n  border: 1px solid #000000;\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  margin-bottom: 10px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.order-item-card.draft-item-card:hover {\r\n  border-color: #000000;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n\r\n.item-header.draft-item-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n  padding-bottom: 8px;\r\n  border-bottom: 1px dashed #000000;\r\n}\r\n\r\n\r\n.item-number.draft-number {\r\n  background-color: #edec5b;\r\n  color: #000000;\r\n  padding: 2px 8px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  margin-right: 10px;\r\n  border: 1px solid #000000;\r\n}\r\n\r\n\r\n.item-system.draft-system {\r\n  font-weight: 600;\r\n  color: #000000;\r\n  flex: 1;\r\n}\r\n\r\n\r\n.item-actions.draft-actions {\r\n  display: flex;\r\n  gap: 5px;\r\n}\r\n\r\n.item-edit-btn.draft-edit-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  padding: 2px 5px;\r\n  border-radius: 4px;\r\n  transition: all 0.2s;\r\n  color: #000000;\r\n}\r\n\r\n.item-edit-btn.draft-edit-btn:hover {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.item-remove-btn.draft-remove-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  padding: 2px 5px;\r\n  border-radius: 4px;\r\n  transition: all 0.2s;\r\n  color: #dc3545;\r\n}\r\n\r\n.item-remove-btn.draft-remove-btn:hover {\r\n  background-color: #f8d7da;\r\n}\r\n\r\n\r\n.item-details.draft-details {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  font-size: 13px;\r\n}\r\n\r\n.item-detail.draft-detail {\r\n  flex: 1 1 calc(50% - 5px);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  color: #000000;\r\n}\r\n\r\n.item-detail.draft-detail .detail-label {\r\n  color: #000000;\r\n}\r\n\r\n.item-detail.draft-detail .detail-value {\r\n  font-weight: 500;\r\n  color: #000000;\r\n}\r\n\r\n\r\n.item-notes.draft-notes {\r\n  flex: 0 0 100%;\r\n  margin-top: 8px;\r\n  padding: 6px;\r\n  background-color: #fff8e7;\r\n  border-radius: 4px;\r\n  color: #000000;\r\n  font-size: 12px;\r\n  font-style: italic;\r\n  border: 1px dashed #000000;\r\n}\r\n\r\n\r\n.loading-drafts {\r\n  text-align: center;\r\n  padding: 20px;\r\n  color: #000000;\r\n  font-style: italic;\r\n}\r\n\r\n\r\n.draft-items-list {\r\n  margin-bottom: 20px;\r\n  background-color: #fff8e7;\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  border: 1px solid #ffc107;\r\n}\r\n\r\n.draft-items-list h3 {\r\n  margin: 0 0 10px 0;\r\n  font-size: 14px;\r\n  color: #856404;\r\n}\r\n\r\n.draft-items-container {\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.draft-item-card {\r\n  background-color: #fff3cd;\r\n  border: 1px solid #ffeeba;\r\n  border-radius: 6px;\r\n  padding: 10px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.draft-item-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n  padding-bottom: 5px;\r\n  border-bottom: 1px dashed #ffeeba;\r\n}\r\n\r\n.draft-number {\r\n  background-color: #ffc107;\r\n  color: #333;\r\n  padding: 2px 6px;\r\n  border-radius: 10px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  margin-right: 8px;\r\n}\r\n\r\n.draft-system {\r\n  font-weight: 500;\r\n  color: #856404;\r\n  flex: 1;\r\n  font-size: 12px;\r\n}\r\n\r\n.draft-actions {\r\n  display: flex;\r\n  gap: 5px;\r\n}\r\n\r\n.draft-edit-btn, .draft-remove-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  padding: 2px 4px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.draft-edit-btn {\r\n  color: #edec5b;\r\n}\r\n\r\n.draft-edit-btn:hover {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.draft-remove-btn {\r\n  color: #dc3545;\r\n}\r\n\r\n.draft-remove-btn:hover {\r\n  background-color: #f8d7da;\r\n}\r\n\r\n.draft-details {\r\n  font-size: 11px;\r\n  color: #856404;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.draft-detail {\r\n  display: flex;\r\n  gap: 5px;\r\n}\r\n\r\n.draft-detail .detail-label {\r\n  color: #856404;\r\n  opacity: 0.8;\r\n}\r\n\r\n.draft-detail .detail-value {\r\n  font-weight: 500;\r\n}\r\n\r\n.draft-notes {\r\n  flex: 0 0 100%;\r\n  margin-top: 5px;\r\n  padding: 4px;\r\n  background-color: #fff3cd;\r\n  border-radius: 4px;\r\n  font-style: italic;\r\n  font-size: 10px;\r\n}\r\n\r\n.loading-drafts {\r\n  text-align: center;\r\n  padding: 20px;\r\n  color: #856404;\r\n  font-style: italic;\r\n}\r\n\r\n\r\n.required-star {\r\n  color: #dc3545;\r\n  margin-left: 2px;\r\n  font-size: 14px;\r\n}\r\n\r\n.form-group .help-text {\r\n  color: #6c757d;\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n  font-style: italic;\r\n}\r\n\r\n.form-group input.error,\r\n.form-group select.error {\r\n  border-color: #dc3545;\r\n  background-color: #fff8f8;\r\n}\r\n\r\n.error-message {\r\n  color: #dc3545;\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.info-row.warning {\r\n  background-color: #fff3cd;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  margin: 5px 0;\r\n}\r\n\r\n.info-row.warning .info-label,\r\n.info-row.warning .info-value {\r\n  color: #856404;\r\n}\r\n\r\n\r\n.required-help {\r\n  color: #6c757d;\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n  font-style: italic;\r\n}\r\n\r\n.required-error {\r\n  color: #dc3545;\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n  font-weight: 500;\r\n  background-color: #f8d7da;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  border-left: 3px solid #dc3545;\r\n}\r\n\r\n.help-text.range-help {\r\n  color: #6c757d;\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n  font-style: italic;\r\n}\r\n\r\n\r\n.form-group select {\r\n  background-color: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n.form-group select:focus {\r\n  outline: none;\r\n  border-color: #edec5b;\r\n  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);\r\n}\r\n\r\n.form-group select.error {\r\n  border-color: #dc3545;\r\n  background-color: #fff8f8;\r\n}\r\n\r\n\r\n.required-star {\r\n  color: #dc3545;\r\n  margin-left: 2px;\r\n  font-size: 14px;\r\n}\r\n\r\n\r\n.item-detail.price .detail-label,\r\n.item-detail.sum .detail-label {\r\n  font-weight: 600;\r\n}\r\n\r\n.item-detail.price .detail-value {\r\n  font-weight: 600;\r\n  color: #17a2b8;\r\n}\r\n\r\n.item-detail.sum .detail-value {\r\n  font-weight: 600;\r\n  color: #070707;\r\n}\r\n\r\n\r\n.confirm-dialog-line {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 8px;\r\n  font-size: 14px;\r\n}\r\n\r\n.confirm-label {\r\n  font-weight: 500;\r\n  color: #666;\r\n  text-align: left;\r\n  flex: 1;\r\n}\r\n\r\n.confirm-value {\r\n  font-weight: 600;\r\n  color: #333;\r\n  text-align: right;\r\n  flex: 1;\r\n  margin-left: 15px;\r\n}\r\n\r\n.confirm-dialog-line.full-width {\r\n  justify-content: center;\r\n  font-weight: 500;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.confirm-dialog-buttons {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 15px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.confirm-dialog-buttons button {\r\n  flex: 1;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.confirm-dialog-buttons .confirm-btn {\r\n  background-color: #edec5b;\r\n  color: #333;\r\n}\r\n\r\n.confirm-dialog-buttons .confirm-btn:hover {\r\n  background-color: #f8f894;\r\n}\r\n\r\n.confirm-dialog-buttons .cancel-btn {\r\n  background-color: #6c757d;\r\n  color: white;\r\n}\r\n\r\n.confirm-dialog-buttons .cancel-btn:hover {\r\n  background-color: #5a6268;\r\n}\r\n\r\n\r\n.item-detail {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 6px 0;\r\n  border-bottom: 1px dashed #f0f0f0;\r\n}\r\n\r\n.item-detail:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.detail-label {\r\n  color: #666;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  flex: 1;\r\n  text-align: left;\r\n}\r\n\r\n.detail-value {\r\n  color: #333;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  text-align: right;\r\n  margin-left: 15px;\r\n  min-width: 80px;\r\n}\r\n\r\n\r\n.item-detail.price .detail-value,\r\n.item-detail.sum .detail-value {\r\n  color: #080808;\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n}\r\n\r\n.item-detail.price .detail-label,\r\n.item-detail.sum .detail-label {\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n.order-disclaimer {\r\n  text-align: left;\r\n}\r\n\r\n.order-disclaimer p {\r\n  text-align: left;\r\n  margin: 5px 0;\r\n}\r\n\r\n\r\n.summary-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 8px 0;\r\n}\r\n\r\n.summary-row .price-value {\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n.current-item-info .info-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 6px 0;\r\n  border-bottom: 1px dashed #e9ecef;\r\n}\r\n\r\n.current-item-info .info-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.info-label {\r\n  color: #666;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  flex: 1;\r\n  text-align: left;\r\n}\r\n\r\n.info-value {\r\n  color: #333;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  text-align: right;\r\n  margin-left: 15px;\r\n}\r\n\r\n\r\n.item-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 10px;\r\n  padding-bottom: 8px;\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.item-system {\r\n  font-weight: 600;\r\n  color: #333;\r\n  flex: 1;\r\n  text-align: left;\r\n  margin-left: 10px;\r\n}\r\n\r\n\r\n.required-star {\r\n  color: #dc3545;\r\n  margin-left: 4px;\r\n  font-size: 14px;\r\n}\r\n\r\n.optional-star {\r\n  color: #6c757d;\r\n  margin-left: 4px;\r\n  font-size: 11px;\r\n  font-style: italic;\r\n  font-weight: normal;\r\n}\r\n\r\n.error-message {\r\n  color: #dc3545;\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n}\r\n\r\n\r\n.system-combobox {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.system-combobox-input {\r\n  width: 100%;\r\n  padding: 10px 35px 10px 12px;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  transition: all 0.2s;\r\n  background-color: #fff;\r\n}\r\n\r\n.system-combobox-input:focus {\r\n  outline: none;\r\n  border-color: #edec5b;\r\n  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);\r\n}\r\n\r\n.system-combobox-input.error {\r\n  border-color: #dc3545;\r\n  background-color: #fff8f8;\r\n}\r\n\r\n.system-combobox-btn {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  font-size: 12px;\r\n  color: #6c757d;\r\n  cursor: pointer;\r\n  padding: 0 4px;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.system-combobox-btn:hover {\r\n  color: #edec5b;\r\n}\r\n\r\n.system-combobox-dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  max-height: 250px;\r\n  overflow-y: auto;\r\n  background-color: white;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  z-index: 1000;\r\n  margin-top: 4px;\r\n}\r\n\r\n.system-combobox-item {\r\n  padding: 10px 12px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  font-size: 14px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.system-combobox-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.system-combobox-item:hover {\r\n  background-color: #f8f9fa;\r\n  color: #edec5b;\r\n}\r\n\r\n.system-combobox-item.selected {\r\n  background-color: #edec5b20;\r\n  color: #edec5b;\r\n  font-weight: 500;\r\n}\r\n\r\n\r\n.color-combobox {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.color-combobox-input {\r\n  width: 100%;\r\n  padding: 10px 35px 10px 12px;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  transition: all 0.2s;\r\n  background-color: #fff;\r\n}\r\n\r\n.color-combobox-input:focus {\r\n  outline: none;\r\n  border-color: #edec5b;\r\n  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);\r\n}\r\n\r\n.color-combobox-input.error {\r\n  border-color: #dc3545;\r\n  background-color: #fff8f8;\r\n}\r\n\r\n.color-combobox-btn {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  font-size: 12px;\r\n  color: #6c757d;\r\n  cursor: pointer;\r\n  padding: 0 4px;\r\n}\r\n\r\n.color-combobox-btn:hover {\r\n  color: #edec5b;\r\n}\r\n\r\n.color-combobox-dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  max-height: 250px;\r\n  overflow-y: auto;\r\n  background-color: white;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  z-index: 1000;\r\n  margin-top: 4px;\r\n}\r\n\r\n.color-combobox-item {\r\n  padding: 10px 12px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  font-size: 14px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.color-combobox-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.color-combobox-item:hover {\r\n  background-color: #f8f9fa;\r\n  color: #edec5b;\r\n}\r\n\r\n\r\n.draft-items-list {\r\n  margin-bottom: 20px;\r\n  background-color: #fff8e7;\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  border: 1px solid #ffc107;\r\n}\r\n\r\n.draft-items-list h3 {\r\n  margin: 0 0 10px 0;\r\n  font-size: 14px;\r\n  color: #856404;\r\n}\r\n\r\n.draft-items-container {\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.loading-drafts {\r\n  text-align: center;\r\n  padding: 20px;\r\n  color: #856404;\r\n  font-style: italic;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
